import bscContractInstance from "./smart-contract-instance";

export default bscContractInstance;
